export default `
uniform float uBorderRadius;
uniform vec2 uDimensions;
uniform sampler2D uDiffuse;
uniform float uColorProgress;
uniform vec3 uCenterColor;
uniform vec3 uBgColor;

varying vec2 vUv;
void main() {
  // set rounded corners
  vec2 aspect = uDimensions / max(uDimensions.x, uDimensions.y);
  vec2 alphaUv = vUv - 0.5;
  float borderRadius = min(uBorderRadius, min(uDimensions.x, uDimensions.y) * 0.5);
  vec2 offset = vec2(borderRadius) / uDimensions;
  vec2 alphaXY = smoothstep(vec2(0.5 - offset), vec2(0.5 - offset - 0.001), abs(alphaUv));
  float alpha = min(1.0, alphaXY.x + alphaXY.y);
  vec2 alphaUv2 = abs(vUv - 0.5);
  float radius = borderRadius / max(uDimensions.x, uDimensions.y);
  alphaUv2 = (alphaUv2 - 0.5) * aspect + radius;
  float roundAlpha = smoothstep(radius + 0.001, radius, length(alphaUv2));

  alpha = min(1.0, alpha + roundAlpha);

  // set texture
  vec3 color = texture2D(uDiffuse, vUv).rgb;
  vec3 centerColor = uCenterColor;

  #if TYPE == 0

  vec3 hsv_center = rgb2hsv(centerColor);
  // hsv_center.g += 0.1 * uColorProgress;
  hsv_center.b += 0.2 * uColorProgress;
  centerColor = hsv2rgb(hsv_center);

  #endif

  #if TYPE == 1

  vec3 hsv_center = rgb2hsv(centerColor);
  hsv_center.g += 0.2 * uColorProgress;
  hsv_center.b += 0.2 * uColorProgress;
  centerColor = hsv2rgb(hsv_center);

  #endif

  #if TYPE == 0
  float centerFactor = smoothstep(0.1, 0.6, abs(vUv.x - 0.5));
  color = mix(centerColor, color, centerFactor * 0.8 + 0.2);
  #endif

  #if TYPE == 1
  float centerFactor = smoothstep(0.0, 0.5, abs(vUv.x - 0.5));
  color = mix(centerColor, color, centerFactor);
  #endif

  color = mix(color, uBgColor, smoothstep(0.2, 1.0, vUv.y) * 0.9);

  #if TYPE == 0
  color = mix(uBgColor, color, smoothstep(0.0, 0.2, vUv.y));
  #endif

  // #if TYPE == 1
  // vec3 hsv = rgb2hsv(color);
  // hsv.g += 0.05 * uColorProgress;
  // hsv.b += 0.05 * uColorProgress;
  // color = hsv2rgb(hsv);
  // #endif

  gl_FragColor = vec4(color, alpha);

}
`
